import type {FondId} from 'src/features/erp-sutor/features/data-view-page';
import type {SimpleFond, TypeOrIdentifiedStub} from 'src/typings';
import type {UIcons} from 'shared/ui-widgets/uicons/types';

const sutorFondIcons: Record<FondId, UIcons> = {
    2: 'building', // Companies

    // Projects
    4: 'check-circle',
    5: 'check-circle',

    // Reports
    20: 'document',
    21: 'document',
    22: 'document',
    26: 'document',
    37: 'document',
    38: 'document',
    44: 'document',
    45: 'document',
    24: 'document',
    800: 'document',

    80: 'edit' // Report reference (průvodka)
};

export function getSutorFondIcon(fond: TypeOrIdentifiedStub<SimpleFond>): UIcons {
    return sutorFondIcons[fond.id];
}